import { LogoVariationI } from "./interfaces";
import { LOGO_VARIATION, LOGO_VARIATION_MAP } from "./constants";

export const getLogoPath = (variation?: LogoVariationI) =>
  LOGO_VARIATION_MAP[variation as LogoVariationI] ||
  LOGO_VARIATION_MAP[LOGO_VARIATION.DEFAULT];
